import Vue from 'vue';
import { gsap } from 'gsap';

Vue.component('logo-ticker-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            tickerContainer: null,
            tickerText: null,
            tickerWidth: null,
            tickerTimelines: [],
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.allTickerHolders = this.$el.querySelectorAll('.logo-ticker');
        this.tickerContainer = this.$el.querySelectorAll('.logo-ticker__wrapper');
        this.tickerText = this.tickerContainer[0].querySelectorAll('.logo-ticker__container');

        EventBus.$on('window-resize', () => {
            this.destroyTicker(true);
        });

        this.initTicker();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        initTicker() {
            // Get css var gap size
            const gapVariable = getComputedStyle(this.$el).getPropertyValue('--gap');
            const isVw = gapVariable.includes('vw');
            const gap = isVw ? (Number(gapVariable.split(/[a-zA-Z]+/g)[0]) / 100) * window.innerWidth : Number(gapVariable.split(/[a-zA-Z]+/g)[0]);

            this.tickerWidth = this.tickerText[0].getBoundingClientRect().width + gap;

            // Reset all moving containers to 0
            gsap.set(this.tickerContainer, {
                x: 0,
            });

            for (let i = 0; i < this.allTickerHolders.length; i++) {
                if (i % 2 !== 0) {
                    const container = this.allTickerHolders[i].querySelectorAll('.logo-ticker__container');
                    const box = container[0].getBoundingClientRect();
                    const logo = this.allTickerHolders[i].querySelector('.logo-ticker__logo-holder');
                    const logoBox = logo.getBoundingClientRect();
                    const resetByAmount = window.innerWidth < 768 ? 2 : 4;
                    gsap.set(container, {
                        x: -box.width * 3 + (logoBox.width * resetByAmount),
                    });
                }
            }

            for (let i = 0; i < this.tickerContainer.length; i++) {
                this.tickerTimelines.push(gsap.timeline());

                // Source: https://codepen.io/GreenSock/pen/QEdpLe
                this.tickerTimelines[i].to(this.tickerContainer[i], {
                    duration: 60,
                    ease: 'none',
                    x: i % 2 === 0 ? -(this.tickerWidth) : this.tickerWidth,
                    modifiers: {
                        x: gsap.utils.unitize((x) => {
                            const value = parseFloat(x) % this.tickerWidth;
                            return i % 2 === 0 ? value : Math.abs(value);
                        }),
                    },
                    repeat: -1,
                });
            }
        },

        freezeTicker(index) {
            if (this.tickerTimelines[index].paused()) {
                return;
            }

            this.tickerTimelines[index].pause();
        },

        unfreezeTicker(index) {
            this.tickerTimelines[index].resume();
        },

        destroyTicker(reinit = false) {
            for (let i = 0; i < this.tickerTimelines.length; i++) {
                this.tickerTimelines[i].kill();
            }

            // Reset to empty array
            this.tickerTimelines = [];

            if (!reinit) {
                return;
            }

            this.initTicker();
        },
    },

    beforeDestroy() {
        this.destroyTicker();
    },
});
